/* Установщик «Кружок и липсинк»: объект в window на том месте порядка скриптов, где стоял assets/bot-app.js.
   В серверном режиме движок шаблона получает сервер экрана (circle-server.ts) и экран who (circle, lipsync) встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createApp } from './engine';
import { createCircleServer, registerCircleEngine } from './circle-server';

export function installApp() {
  const server = isServerMode();
  createApp(server ? createCircleServer : null);
  if (server) registerCircleEngine();
}
